import { useEffect, useRef } from "react";
import logger from '../utils/logger';

const AUTO_LOGOUT_MINUTES = 1; // 1 minute

export const useForceAutoLogout = (isModalOpen, onForceLogout) => {
  const timer = useRef(null);

  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      logger("log", "Auto logout triggered");
      onForceLogout();
    }, AUTO_LOGOUT_MINUTES * 60 * 1000);
  };

  useEffect(() => {
    if (!isModalOpen) {
      if (timer.current) clearTimeout(timer.current);
      return;
    }

    const events = ["mousemove", "keydown", "scroll", "click"];
    const handleActivity = () => resetTimer();

    events.forEach((event) =>
      window.addEventListener(event, handleActivity)
    );

    resetTimer(); // start countdown when modal opens

    return () => {
      if (timer.current) clearTimeout(timer.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
    };
  }, [isModalOpen, onForceLogout]);
};

